import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card__head d-flex align-items-center pr-4" }
const _hoisted_2 = { class: "d-flex align-items-center text-uppercase mb-0" }
const _hoisted_3 = { class: "bt-icon bt-icon--m" }
const _hoisted_4 = { class: "ml-2" }
const _hoisted_5 = { class: "d-flex align-items-center ml-auto" }
const _hoisted_6 = { class: "btn-stripped d-flex align-items-center" }
const _hoisted_7 = { class: "bt-icon bt-icon--sm mr-3 text-gray" }
const _hoisted_8 = { class: "btn-stripped d-flex align-items-center" }
const _hoisted_9 = { class: "bt-icon bt-icon--sm mr-3 text-gray" }
const _hoisted_10 = { class: "btn-stripped d-flex align-items-center" }
const _hoisted_11 = { class: "bt-icon bt-icon--sm mr-3 text-gray" }
const _hoisted_12 = { class: "btn-stripped d-flex align-items-center" }
const _hoisted_13 = { class: "bt-icon bt-icon--sm mr-3 text-gray" }
const _hoisted_14 = { class: "btn-stripped text-danger d-flex align-items-center" }
const _hoisted_15 = { class: "list-blocks" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { class: "d-flex align-items-stretch mb-0 w-100" }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InlineSvgScoped = _resolveComponent("InlineSvgScoped")
  const _component_Button = _resolveComponent("Button")
  const _component_ElDropdownItem = _resolveComponent("ElDropdownItem")
  const _component_Divider = _resolveComponent("Divider")
  const _component_ElDropdownMenu = _resolveComponent("ElDropdownMenu")
  const _component_ElDropdown = _resolveComponent("ElDropdown")
  const _component_ActionSceneSlide = _resolveComponent("ActionSceneSlide")
  const _component_TriggerSceneSlide = _resolveComponent("TriggerSceneSlide")
  const _component_ConditionSceneSlide = _resolveComponent("ConditionSceneSlide")
  const _component_Card = _resolveComponent("Card")

  return (_openBlock(), _createBlock(_component_Card, { class: "card--primary card--scene mb-3" }, {
    content: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("h4", _hoisted_2, [
          _createVNode("span", _hoisted_3, [
            _createVNode(_component_InlineSvgScoped, {
              src: _ctx.sceneIcon,
              "aria-label": "icon-device"
            }, null, 8, ["src"])
          ]),
          _createVNode("span", _hoisted_4, _toDisplayString(_ctx.scene.name), 1)
        ]),
        _createVNode("div", _hoisted_5, [
          _createVNode(_component_ElDropdown, {
            trigger: "click",
            placement: "bottom-end",
            "popper-class": "el-dropdown__popper el-dropdown--context"
          }, {
            dropdown: _withCtx(() => [
              _createVNode(_component_ElDropdownMenu, { style: {"width":"300px"} }, {
                default: _withCtx(() => [
                  (_ctx.scene.isDisabled)
                    ? (_openBlock(), _createBlock(_component_ElDropdownItem, {
                        key: 0,
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleAction('enable')))
                      }, {
                        default: _withCtx(() => [
                          _createVNode("button", _hoisted_6, [
                            _createVNode("span", _hoisted_7, [
                              _createVNode(_component_InlineSvgScoped, {
                                src: 
                                                    require('@/assets/images/icons/icon-confirm-outline.svg')
                                                ,
                                "aria-label": "icon-confirm-outline"
                              }, null, 8, ["src"])
                            ]),
                            _createVNode("span", null, _toDisplayString(_ctx.$t("AppResource.Enable")), 1)
                          ])
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_component_ElDropdownItem, {
                        key: 1,
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleAction('disable')))
                      }, {
                        default: _withCtx(() => [
                          _createVNode("button", _hoisted_8, [
                            _createVNode("span", _hoisted_9, [
                              _createVNode(_component_InlineSvgScoped, {
                                src: 
                                                    require('@/assets/images/icons/icon-ban-light.svg')
                                                ,
                                "aria-label": "icon-ban-light"
                              }, null, 8, ["src"])
                            ]),
                            _createVNode("span", null, _toDisplayString(_ctx.$t("AppResource.Disable")), 1)
                          ])
                        ]),
                        _: 1
                      })),
                  (_ctx.isCustomScene)
                    ? (_openBlock(), _createBlock(_component_ElDropdownItem, {
                        key: 2,
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleAction('duplicate')))
                      }, {
                        default: _withCtx(() => [
                          _createVNode("button", _hoisted_10, [
                            _createVNode("span", _hoisted_11, [
                              _createVNode(_component_InlineSvgScoped, {
                                src: 
                                                    require('@/assets/images/icons/icon-duplication.svg')
                                                ,
                                "aria-label": "icon-duplication"
                              }, null, 8, ["src"])
                            ]),
                            _createVNode("span", null, _toDisplayString(_ctx.$t("AppResource.Duplicate")), 1)
                          ])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_ElDropdownItem, {
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleAction('edit')))
                  }, {
                    default: _withCtx(() => [
                      _createVNode("button", _hoisted_12, [
                        _createVNode("span", _hoisted_13, [
                          _createVNode(_component_InlineSvgScoped, {
                            src: 
                                                    require('@/assets/images/icons/icon-edit.svg')
                                                ,
                            "aria-label": "icon-edit"
                          }, null, 8, ["src"])
                        ]),
                        _createVNode("span", null, _toDisplayString(_ctx.$t("AppResource.Edit")), 1)
                      ])
                    ]),
                    _: 1
                  }),
                  (_ctx.isCustomScene)
                    ? (_openBlock(), _createBlock(_Fragment, { key: 3 }, [
                        _createVNode(_component_Divider),
                        _createVNode(_component_ElDropdownItem, {
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.handleAction('delete')))
                        }, {
                          default: _withCtx(() => [
                            _createVNode("button", _hoisted_14, _toDisplayString(_ctx.$t("AppResource.DeleteTheScene")), 1)
                          ]),
                          _: 1
                        })
                      ], 64))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _withDirectives(_createVNode(_component_Button, { class: "p-button p-button-text p-button-secondary py-0 ml-2" }, {
                default: _withCtx(() => [
                  _createVNode(_component_InlineSvgScoped, {
                    src: 
                                    require('@/assets/images/icons/icon-ellipsis-v.svg')
                                ,
                    "aria-label": "icon-ellipsis-v"
                  }, null, 8, ["src"])
                ]),
                _: 1
              }, 512), [
                [_vShow, !_ctx.disableActions]
              ])
            ]),
            _: 1
          })
        ])
      ]),
      _createVNode("ul", _hoisted_15, [
        (_ctx.scene.actions && _ctx.scene.actions.length)
          ? (_openBlock(), _createBlock("li", _hoisted_16, [
              _createVNode("div", _hoisted_17, [
                _createVNode(_component_ActionSceneSlide, {
                  sceneId: _ctx.scene.id,
                  actions: _ctx.scene.actions,
                  plant: _ctx.currentPlant
                }, null, 8, ["sceneId", "actions", "plant"])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.scene.triggers && _ctx.scene.triggers.length)
          ? (_openBlock(), _createBlock("li", _hoisted_18, [
              _createVNode(_component_TriggerSceneSlide, {
                sceneId: _ctx.scene.id,
                triggers: _ctx.scene.triggers,
                plant: _ctx.currentPlant
              }, null, 8, ["sceneId", "triggers", "plant"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.scene.conditions && _ctx.scene.conditions.length)
          ? (_openBlock(), _createBlock("li", _hoisted_19, [
              _createVNode(_component_ConditionSceneSlide, {
                sceneId: _ctx.scene.id,
                conditions: _ctx.scene.conditions,
                plant: _ctx.currentPlant
              }, null, 8, ["sceneId", "conditions", "plant"])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}